import { useSeoMeta, useHead } from "@unhead/react"
import Navbar from "@/components/Navbar"
import HeroSection from "@/components/HeroSection"
import FeaturedGames from "@/components/FeaturedGames"
import ValueProp from "@/components/ValueProp"
import LatestBling from "@/components/LatestBling"
import AboutPreview from "@/components/AboutPreview"
import CTABanner from "@/components/CTABanner"
import Footer from "@/components/Footer"

export default function Home() {
  useSeoMeta({
    title: "Bling Skins - Luxury Gaming Cosmetics Guide",
    description: "Level up your gaming aesthetic with the rarest gold, diamond, and prestige skins in Apex Legends, Fortnite, and Valorant.",
    ogTitle: "Bling Skins - Luxury Gaming Cosmetics Guide",
    ogDescription: "Level up your gaming aesthetic with the rarest gold, diamond, and prestige skins in Apex Legends, Fortnite, and Valorant.",
    ogImage: "https://www.blingskins.com/og-home.jpg",
    ogUrl: "https://www.blingskins.com/",
    twitterCard: "summary_large_image",
    twitterTitle: "Bling Skins - Luxury Gaming Cosmetics Guide",
    twitterDescription: "Your ultimate guide to premium gaming cosmetics.",
    twitterImage: "https://www.blingskins.com/og-home.jpg",
  })

  useHead({
    link: [
      { rel: "canonical", href: "https://www.blingskins.com/" }
    ],
    script: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "BlingSkins Hub",
          "url": "https://www.blingskins.com",
          "description": "The ultimate guide to luxury gaming cosmetics",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.blingskins.com/blog?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })
      }
    ]
  })

  return (
    <div className="min-h-screen bg-[#0A0A0F]">
      <Navbar />
      <HeroSection />
      <FeaturedGames />
      <ValueProp />
      <LatestBling />
      <AboutPreview />
      <CTABanner />
      <Footer />
    </div>
  )
}
